import React from 'react';
import firebase from 'firebase/compat/app';
import "firebase/compat/database";
import SaveIcon from '@material-ui/icons/Save';
import { CircularProgress, IconButton, makeStyles, TextField, Theme } from '@material-ui/core';
import CSVReader from './CSVReader';
import { POSITIONS_OPTIONS, TEAMS_OPTIONS } from '../model/Options';
import { WeeklyProjectionPlayer } from '../model/WeeklyProjectionPlayer';
import { convertWeeklyProjection } from '../converter/WeeklyProjectionConverter';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    box: {
        width: '300px',
        margin: '5px'
    },
    error: {
        whiteSpace: 'pre-wrap',
        color: 'red'
    },
    success: {
        color: 'green'
    }
}));

interface WeeklyProjectionProps {
}

export const WeeklyProjection: React.FC<WeeklyProjectionProps> = (props: WeeklyProjectionProps) => {
    const classes = useStyles(props);
    const [result, setResult] = React.useState<any>();
    const [isUpdating, setIsUpdating] = React.useState(false);
    const [error, setError] = React.useState<String | null>(null);
    const [success, setSuccess] = React.useState(false);
    const [week, setWeek] = React.useState("");

    const validateProjection = (players: WeeklyProjectionPlayer[]) => {
        var res = "";
        players.forEach(p => {
            if (!TEAMS_OPTIONS.includes(p.team)) {
                res += `team error with player: ${p.name}, ${p.team}\n`;
            } else {
                p.pos.split("/").forEach(pos => {
                    if (!POSITIONS_OPTIONS.includes(pos)) {
                        res += `position error with player: ${p.name}, ${pos}\n`;
                    }
                });
            }
        });

        return res;
    }

    const handleSave = () => {
        setSuccess(false);
        if (!result) {
            setError('לא נבחר קובץ')
            return;
        }
        if (!week || week === "") {
            setError("לא הוקלד שבוע")
            return;
        }
        setError(null);
        setIsUpdating(true);
        const projections = convertWeeklyProjection(result.data);
        const err = validateProjection(projections);
        if (err) {
            setError(err);
            setIsUpdating(false);
        } else {
            firebase.database().ref().child('weekly_projections').set({
                projections: projections,
                lut: firebase.database.ServerValue.TIMESTAMP,
                week: week
            }).then(() => {
                setIsUpdating(false);
                setSuccess(true);
            }).catch(err => {
                setIsUpdating(false);
                setError("שגיאה");
            });
        }
    }

    return <div className={classes.root}>
        <TextField label="Week" variant="outlined" 
            required
            value={week}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setWeek(event.target.value);
              }}>

        </TextField>
        <div className={classes.box}>
            <CSVReader setResult={setResult} />
        </div>
        <IconButton
            disabled={isUpdating}
            onClick={handleSave}>
            <SaveIcon />
        </IconButton>
        {isUpdating && <CircularProgress color="inherit" />}
        <p className={classes.error}>{error}</p>
        {success && <span className={classes.success}>עודכן בהצלחה</span>}
    </div>
}